/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 */
(function() {
  let lastScrollY = 0;

  function lockBody() {
    if (document.body.classList.contains('body-lock')) return;
    lastScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.top = `-${lastScrollY}px`;
    document.body.classList.add('body-lock');
  }

  function unlockBody() {
    if (!document.body.classList.contains('body-lock')) return;
    document.body.classList.remove('body-lock');
    document.body.style.top = '';
    window.scrollTo(0, lastScrollY || 0);
  }

  function drawerIsOpen() {
    return !!document.querySelector(
      '.upcart-drawer.open, .upcart-drawer--open, .upcart--open, [class*="upcart"][class*="open"]'
    );
  }

  const observer = new MutationObserver(() => {
    drawerIsOpen() ? lockBody() : unlockBody();
  });

  observer.observe(document.body, { attributes: true, childList: true, subtree: true });

  document.addEventListener('touchmove', function(e) {
    const drawer = document.querySelector('.upcart-drawer, .upcart-sidebar, .upcart-cart');
    if (!drawer) return;
    if (drawer.contains(e.target)) {
      if (e.touches && e.touches.length === 1) {
        const t = e.touches[0];
        const s = drawer.dataset;
        if (!s.tx) { s.tx = t.clientX; s.ty = t.clientY; }
        const dx = Math.abs(t.clientX - s.tx), dy = Math.abs(t.clientY - s.ty);
        if (dx > dy) e.preventDefault();
      }
    }
  }, { passive: false });
})();

/* === Donaris | UpCart: mostrar valor do desconto por item === */
(function () {
  // formata número para BRL
  function formatBRL(value) {
    try {
      return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    } catch (e) {
      // fallback simples
      return "R$ " + value.toFixed(2).replace(".", ",");
    }
  }

  // pega o cart do Shopify
  async function getCart() {
    const res = await fetch("/cart.js");
    return await res.json();
  }

  // tenta achar o "root" de cada item no UpCart
  function getUpcartItemNodes() {
    // cada item costuma ter id tipo "VARIANTID:HASH"
    return Array.from(document.querySelectorAll('[id*=":"][class*="ProductRow_product__"], [id*=":"][class*="upcart-product-item"], [id*=":"]'))
      .filter(el => el.querySelector(".DiscountCodeBadge_title__ , .upcart-discount-code-text"));
  }

  // soma descontos do item no cart.js
  function getItemDiscountAmount(cartItem) {
    if (!cartItem || !cartItem.discount_allocations) return 0;
    let total = 0;
    cartItem.discount_allocations.forEach(d => {
      total += Number(d.amount) || 0;
    });
    return total;
  }

  async function applyDiscountBadges() {
    let cart;
    try {
      cart = await getCart();
    } catch (e) {
      return;
    }

    const upItems = getUpcartItemNodes();
    if (!upItems.length) return;

    upItems.forEach(node => {
      const badge = node.querySelector(".DiscountCodeBadge_title__, .upcart-discount-code-text");
      if (!badge) return;

      // evita duplicar texto
      if (!badge.dataset.originalText) {
        badge.dataset.originalText = badge.textContent.trim();
      }

      // pega variant_id do id="VARIANTID:xxxx"
      const rawId = node.getAttribute("id") || "";
      const variantId = Number(rawId.split(":")[0]);
      if (!variantId) return;

      // acha o item correspondente no cart.js
      const cartItem = cart.items.find(i => Number(i.variant_id) === variantId);
      if (!cartItem) return;

      const discountValue = getItemDiscountAmount(cartItem);

      // monta texto final
      const original = badge.dataset.originalText;
      const finalText = `${original} (${discountValue > 0 ? "−" : "−"}${formatBRL(discountValue)})`;

      badge.textContent = finalText;
    });
  }

  // roda ao abrir UpCart e quando mudar
  const obs = new MutationObserver(() => {
    // se o drawer estiver visível, atualiza
    const drawerOpen = document.querySelector(".upcart-drawer.open, .upcart-drawer--open, .upcart--open, [class*='upcart'][class*='open']");
    if (drawerOpen) applyDiscountBadges();
  });

  obs.observe(document.body, { childList: true, subtree: true });

  // primeira tentativa quando a página carrega
  document.addEventListener("DOMContentLoaded", applyDiscountBadges);
})();
